import { Route, Routes, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "./App.css";
import Contact from "./staticpages/Contact";
import Form from "./component/Form";
import Home from "./pages/Home";
import Testimonial from "./staticpages/Testimonial";
import FormExample from "./component/FormExample";
import SliderCarousel from "./component/SliderCarousel";
import CustomAccordion from "./component/CustomAccordion";
import Imgslider from "./component/Imgslider";
import ScrollToTop from "./component/ScrollToTop";
import ProductList from "./pages/ProductList";
import ProductDetail from "./pages/ProductDetail";
import Wishlist from "./pages/Wishlist";
import NotFound from "./pages/NotFound";
import Login from "./component/login/Login";
import Register from "./component/login/Register";
import LoginWithEmail from "./component/login/LoginWithEmail";
import ResetPassword from "./component/login/ResetPassword";
import RegisterTest from "./component/login/RegisterTest";
import MyOrders from "./pages/MyOrders";
import PrivateRoute from "./component/Routes/PrivateRoute";
import MyAccountDetail from "./pages/MyAccountDetail";
import OrdersDetail from "./pages/OrdersDetail";
import CustomTailoring from "./staticpages/CustomTailoring";
import MyAddress from "./pages/MyAddress";
import Pages from "./staticpages/Pages";
import MyMeasurement from "./pages/MyMeasurement";
import BlogList from "./Blog/BlogList";
import BlogDetail from "./Blog/BlogDetail";
import TrackOrder from "./staticpages/TrackOrder";
import SupportTicket from "./pages/SupportTicket";
import SupportTicketView from "./pages/SupportTicketView";
import ProductSearchList from "./pages/ProductSearchList";
import StripePaymentSuccess from "./pages/StripePaymentSuccess";
import StripePaymentFailed from "./pages/StripePaymentFailed";
import RecoverPassword from "./component/login/RecoverPassword";
import Reels from "./staticpages/Reels";
import Test from "./staticpages/Test";
import CheckoutPhonePe from "./component/Checkout/checkoutPhonePe";
import PhonePePaymentFailed from "./pages/PhonePePaymentFailed";
import PhonePePaymentSuccess from "./pages/PhonePePaymentSuccess";
import ClientDiaries from "./staticpages/ClientDiaries";
import ClientDiariesSingle from "./staticpages/ClientDiariesSingle";
import Celebrity from "./staticpages/Celebrity";
import StoreGallery from "./pages/StoreGallery";
import NewHome from "./pages/NewHome";
import MaansiKetan from "./staticpages/MaansiKetan";
import MaansiKetan2 from "./staticpages/MaansiKetan2";
import PeopleOfChaashni from "./staticpages/PeopleOfChaashni";
import LoginSignup from "./component/login/LoginSignup";
import NewLoginRegister from "./component/Layout/NewLoginRegister";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reviews from "./staticpages/Reviews";
import StoreGalleryDubai from "./pages/StoreGalleryDubai";
import NewAboutChaashni from "./staticpages/NewAboutChaashni";
import { useEffect } from "react";
import TheWomenOfChaashni from "./staticpages/TheWomenOfChaashni";
import HomePageWhatsAppInsta from "./pages/HomePageWhatsAppInsta";
import OfflineAppointment from "./staticpages/OfflineAppointment";
import TryOn from "./tryon/Tryon";
import TryOnDetailPage from "./tryon/TryOnDetailPage";
import ChangeCountry from "./component/ChangeCountry/ChangeCountry";
import ShopByCategory from "./component/Homecomponent/ShopByCategory";
import ShopByCollection from "./pages/ShopByCollection";
import MadeForHer from "./pages/MadeForHer";
import CheckoutPhonePeCheckout from "./component/Checkout/checkoutPhonePeCheckout";
/* import N8nChat from "./component/N8n/N8nChat"; */

function App() {
 /* const location = useLocation();
  const path = location.pathname;
  const hash = location.hash;

   const shouldShowComponent =
    path === '/aboutchaashni' &&
    ['#PeopleOfChaashni', '#gallery', '#about'].includes(hash);

    useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]); */

  const location = useLocation();
  const noScrollPages = ["/aboutchaashni"];
  const showScrollToTop = !noScrollPages.includes(location.pathname);

  return (
    <>   

     {/* {shouldShowComponent && <ScrollToTop />} */}
      {/* <ScrollToTop /> */}
      {showScrollToTop && <ScrollToTop />}
      <Routes>
      <Route path="/old" element={<Home />} />
      <Route path="/WhatsappInsta" element={<HomePageWhatsAppInsta />} />
      <Route path="/" element={<NewHome />} />        
        <Route path="/" element={<PrivateRoute />}>
        {/*
        <Route path="/checkout" element={<Checkout />}/> 
        <Route path="/checkout" element={<CheckoutStripe/>}/>
        <Route path="/checkout-cod" element={<CheckoutCod/>}/>
        */}
          <Route path="/cart" element={<CheckoutPhonePe />} />
          <Route path="/checkout" element={<CheckoutPhonePeCheckout />} />
          <Route path="/myorders" element={<MyOrders />} />
          <Route path="/my-account-detail" element={<MyAccountDetail />} />
          <Route path="/my-address" element={<MyAddress />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/orders-detail/:order_no" element={<OrdersDetail />} />
          <Route path="/trackorder/:order_no" element={<TrackOrder />} />
          <Route path="/support-ticket" element={<SupportTicket />} />
          <Route path="/support-ticket/:ticketId" element={<SupportTicketView />} />
        </Route>
        {/* <Route path="/faq" element={<Faq />} />
        <Route path="/returns-exchanges-and-cancellations" element={<ReturnsExchanges />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/customer-care" element={<CustomerCare />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/shipping-information" element={<ShippingInformation />} />
        <Route path="/copyright" element={<Copyright />} />*/}
        <Route path="/custom-tailoring" element={<CustomTailoring />} />
        <Route path="/measurements" element={<MyMeasurement />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/pages/:slug" element={<Pages />} />
        <Route path="/login" element={<Login />} />
        <Route path="/loginsignup" element={<LoginSignup />} />
        <Route path="/register" element={<Register />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/recoverpassword" element={<RecoverPassword />} />
        <Route path="/loginwithemail" element={<LoginWithEmail />} />
        <Route path="/chaashni-stories" element={<Testimonial />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/test" element={<Test />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/form" element={<Form />} />
        <Route path="/newform" element={<FormExample />} />
        <Route path="/slider" element={<SliderCarousel />} />
        <Route path="/accordion" element={<CustomAccordion />} />
        <Route path="/imgslider" element={<Imgslider />} />
        <Route path="/productList" element={<ProductList />} />
        <Route path="/category/:categorySlug" element={<ProductList />} />
        <Route path="/search" element={<ProductSearchList />} />
        <Route path="/category/:categorySlug/:subCategorySlug?" element={<ProductList />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/payment-success" element={<StripePaymentSuccess />} />
        <Route path="/payment-failed" element={<StripePaymentFailed />} />
        <Route path="/phonepe-payment-success" element={<PhonePePaymentSuccess />} />
        <Route path="/phonepe-payment-failed" element={<PhonePePaymentFailed />} />
        <Route path="/notfound" element={<NotFound />} />
        {/*Testing Path   */}
        <Route path="/register-test" element={<RegisterTest />} />
        <Route path="/reels" element={<Reels />} />
        <Route path="/clientdiaries" element={<ClientDiaries />} />
        <Route path="/clientdiaries2" element={<ClientDiariesSingle />} />
        <Route path="/celebrity" element={<Celebrity />} />
        <Route path="/chaashni-experience-center-delhi" element={<StoreGallery />} />         
        <Route path="/chaashni-experience-center-dubai" element={<StoreGalleryDubai />} />
        <Route path="/maansiandketan" element={<MaansiKetan />} /> 
        <Route path="/maansiandketan2" element={<MaansiKetan2 />} />
        <Route path="/peopleofchaashni" element={<PeopleOfChaashni />} />
        <Route path="/testlogin" element={<NewLoginRegister show="true" />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/aboutchaashni" element={<NewAboutChaashni />} /> 
        <Route path="/the-women-of-chaashni" element={<TheWomenOfChaashni />} />
        <Route path="/offline" element={<OfflineAppointment />} />
        <Route path="/tryon" element={<TryOn />} />
        <Route path="/tryondetail" element={<TryOnDetailPage />} />
        <Route path="/ChangeCountry" element={<ChangeCountry />}/>
        <Route path="/shop" element={<ShopByCollection />} />
        <Route path="/made-for-her" element={<MadeForHer />} />
      </Routes>
      <ToastContainer position="bottom-center" />
      {/* <N8nChat/> */}
    </>
  );
}
export default App;